import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TypeBagsWeight,  StatusBag} from "@app/enums";
import { BagAncillarieInt,  } from '@app/interfaces';
import { Passenger } from '@app/models';

/**
 * Componente que representa la tabla de maletas de mano (carry-on).
 * Permite gestionar la visualización y selección de maletas adicionales.
 */
@Component({
    selector: 'am-bags-table-carryon',
    templateUrl: './am-bags-table-carryon.component.html',
    styleUrls: ['./am-bags-table-carryon.component.scss'],
    standalone: false
})
export class AmBagsTableCarryonComponent implements OnInit {

   // #region Vars input
  /**
   * Lista de maletas adicionales para carry-on.
   */
  @Input() extraBagsCarryon: BagAncillarieInt[];
  
  /**
   * Familia tarifaria actual.
   */
  @Input() fareFamily: string;

  /**
   * Lista de pasajeros.
   */
  @Input() passengers: Passenger[];

  /**
   * Evento para emitir la actualización de maletas.
   */
  @Output() updateBags: EventEmitter<any> = new EventEmitter();
  // #endregion Variables de entrada

  /**
   * Enumeración para tipos de peso de maletas.
   */
  BagsWeight = TypeBagsWeight; 

  /**
   * Código de moneda para las maletas.
   */
  currencyCodeBags: string;

  /**
   * Indica si la vista es para Premier.
   */
  isViewPremier: boolean = false;

  /**
   * Enumeración para estado de maletas.
   */
  StatusBag = StatusBag; 

  /**
   * Estado global de las maletas.
   */
  statusGlobalBags: StatusBag;

  /**
   * Total del monto de las maletas.
   */
  totalAmountBags: number = 0;


  constructor() {
  }

  ngOnInit(): void {
    this.initPage();
  }

  // #region Functions internals
  initPage(){
    this.getStatusGlobalBags();
  }
  /**
   * Obtiene el estado global de las maletas con base en los pasajeros.
   */
  getStatusGlobalBags(){
    const statusPassangers = this.passengers.map(x => { return x.getStatusBagColumnCarryon });
    const bagsInclude = statusPassangers.find(x => x == StatusBag.INCLUDE);
    const bagsPaid = statusPassangers.find(x => x == StatusBag.PAID);
    const bagsToPay = statusPassangers.find(x => x == StatusBag.TO_PAY);

    if(bagsToPay) {
      this.statusGlobalBags = StatusBag.TO_PAY;
    }else if (bagsPaid) {
      this.statusGlobalBags = StatusBag.PAID;
    }else if(bagsInclude)
      this.statusGlobalBags = StatusBag.INCLUDE;
    else
      this.statusGlobalBags = StatusBag.NONE

      //get total bags
    this.totalAmountBags = 0;
    if(this.statusGlobalBags == StatusBag.TO_PAY) {
      this.passengers.map(x=> {
        const bags = x.bagStackCarryon.filter(bag=> bag.statusBag == StatusBag.TO_PAY);
        bags?.map(x=> {
          this.totalAmountBags += x.currency?.total || 0;
          this.currencyCodeBags = x.currency?.currencyCode || ''
        })
      });
    }

    this.updateBags.emit({
      totalAmountBags : this.totalAmountBags,
      currencyCodeBags: this.currencyCodeBags
    });
  }

  /**
   * Calcula el total de maletas seleccionadas por tipo de peso.
   * @param bagWeight Tipo de peso de la maleta.
   * @returns Número total de maletas seleccionadas.
   */
  totalBagsForWeight(bagWeight: TypeBagsWeight){
    let total = 0;

    this.passengers.map(passenger => {
      total += passenger.bagStackCarryon.filter(bag=> bag.typeBagWeight == bagWeight && bag.selected)?.length || 0
    });

    return total;
  }


  // #endregion Functions internals

  // #region Events
  onRedeemed(event){
  }

    /**
   * Maneja el cambio de peso adicional de maletas.
   * @param $event Evento del cambio.
   * @param passenger Pasajero afectado.
   */

  handleChangeExtraWeightBags($event,passenger: Passenger){
    passenger.onPlusExtraWeightCarryon($event,this.extraBagsCarryon)
    this.getStatusGlobalBags();
  }
  // #endregion Events

}
